import {
  SET_LESSONS,
  SET_LESSON,
  FINISH_LESSON,
  SET_MESSAGE,
  SET_MESSAGE_MARK,
  SET_CURRENT_CHAT_ID
} from '@/store/mutations.js';
import { NOTIFICATION_DURATION } from '@/js/constants/index.js';
import app from '@/js/app.js';
import apiRequest from '@/js/helpers/apiRequest.js';

export default {
  state: {
    lessons: [],
    currentLessonId: null,
    lessonsLoad: true
  },

  mutations: {
    [SET_LESSONS]: (state, { lessons }) => {
      state.lessons.push(...lessons);
      state.lessonsLoad = false;
    },

    [SET_LESSON]: (state, { lesson }) => {
      state.lessons.push(lesson);
    },

    [FINISH_LESSON]: (state, { id, video }) => {
      state.lessons = state.lessons.filter(lesson => lesson.id !== id);
      console.log('Finish video stream', video);
    },

    [SET_MESSAGE]: (state, { message, lessonId }) => {
      console.log(lessonId, 'lessonId');
      const lesson = state.lessons.find(lesson => lesson.id === lessonId);

      lesson.messages.push(message);
    },

    [SET_MESSAGE_MARK]: (state, { lessonId, messageId, mark }) => {
      const lesson = state.lessons.find(lesson => lesson.id === lessonId);

      if (lesson && lesson.messages) {
        lesson.messages.find(message => message.id === messageId).mark = mark;
      }
    },

    [SET_CURRENT_CHAT_ID]: (state, { lessonId }) => {
      state.currentLessonId = lessonId;
    }
  },

  actions: {
    getLesson: async ({ commit, rootState }) => {
      try {
        const res = await apiRequest('lessons', 'GET', null, true);

        if (res.error) {
          app.$f7.toast
            .create({
              position: 'bottom',
              destroyOnClose: true,
              closeTimeout: NOTIFICATION_DURATION,
              text: res.error
            })
            .open();

          return;
        }

        const lessons = res.success.map(
          ({ id, video, start, messages, user: { id: userId, avatar, name } }) => ({
            id,
            start,
            video,
            user: {
              id: userId,
              avatar,
              name
            },
            messages:
              messages &&
              messages.map(
                ({
                  id,
                  mark,
                  quote,
                  quote_date,
                  lesson_id,
                  created_at,
                  user_id,
                  text,
                  attachments
                }) => ({
                  id,
                  lessonId: lesson_id,
                  type: user_id === rootState.user.info.id ? 'sent' : 'received',
                  mark,
                  quote,
                  quoteDate: quote_date,
                  date: created_at,
                  userId: user_id,
                  text,
                  attachment:
                    attachments && attachments.length
                      ? {
                          src: attachments[0].src,
                          name: attachments[0].name,
                          type: attachments[0].type,
                          size: attachments[0].size
                        }
                      : null
                })
              )
          })
        );

        commit(SET_LESSONS, { lessons });
      } catch (err) {
        app.$f7.toast
          .create({
            position: 'bottom',
            destroyOnClose: true,
            closeTimeout: NOTIFICATION_DURATION,
            text: 'Failed to load data'
          })
          .open();
        console.error(err);
      }
    },

    sendMessage: async (
      { commit },
      { lessonId, messageId = '', text = '', attachment = [] } = {}
    ) => {
      const body = new FormData();
      body.append('lesson_id', lessonId);
      body.append('message_id', messageId);
      body.append('text', text);
      body.append('files[]', attachment);

      const res = await apiRequest('lesson/message/create', 'POST', body, true);

      if (res.error) {
        throw { customeError: res.error };
      }
    },

    // eslint-disable-next-line no-unused-vars
    finishLesson: async ({ commit }, { id }) => {
      const res = await apiRequest(`lesson/end/${id}`, 'POST', null, true);

      if (res.error) {
        throw { customeError: res.error };
      }
    }
  }
};
